import React, { useEffect, useState } from "react";
import "./VipMembers.css"; // Create a separate CSS file for styling
import Navbar from "../Home/Navbar";
import Footer from "../Home/Footer";

const VipMembers = () => {
  const [vipMembers, setVipMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVipMembers = async () => {
      try {
        const response = await fetch("https://api.garudasena.org/api/vip");
        if (!response.ok) {
          throw new Error("Failed to fetch VIP members");
        }
        const data = await response.json();
        setVipMembers(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchVipMembers();
  }, []);

  if (loading) {
    return <div className="loading-text">Loading VIP members...</div>;
  }

  if (error) {
    return <div className="error-text">Error: {error}</div>;
  }

  return (
    <>
      <Navbar />
      <div className="vip-container">
        {vipMembers.map((vip) => (
   <div key={vip.id} className="vip-card">
  <div className="vip-badge">👑</div>
  <div className="vip-image-wrapper">
    <img src={vip.photo} alt={vip.name} className="vip-image" />
  </div>
  <h3 className="vip-name">{vip.name}</h3>
  <p className="vip-designation">{vip.designation}</p>
</div>

        ))}
      </div>
      <Footer />
    </>
  );
};

export default VipMembers;
